module.exports = __webpack_public_path__ + "media/images/illustrations/donkeycoins-falling-coin-crossed-4c0029999c0a383e08f8d46ef2760277.svg";